import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { BaoHiem, ChiTietBaoHiem } from "../models/baohiem/BaoHiem";
import intance from "../utils/axios";

export const layDsBaoHiem = async (start: number, length: number, nam?: number | null, loaiBaoHiem?: number | null, trangThai?: number | null) => {
    var rs = {
        data: [],
        recordsTotal: 0,
    }
    let qs = `?start=${start}&length=${length}`;
    if (nam !== null && nam !== undefined) qs += `&nam=${nam}`;
    if (loaiBaoHiem !== null && loaiBaoHiem !== undefined) qs += `&loaiBaoHiem=${loaiBaoHiem}`;
    if (trangThai !== null && trangThai !== undefined) qs += `&trangThai=${trangThai}`;
    await intance.get(ApiPaths.baoHiem.layDsBaoHiem + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return rs;
};

export const xoaBaoHiemThang = async (id: number) => {
    await intance.post(ApiPaths.baoHiem.xoaBaoHiemThang + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
}
export const layDsBaoHiemTheoNam = async (nam?: number) => {
    var rs: Array<BaoHiem> = [];
    const qs = nam ? `?nam=${nam}` : '';
    await intance.get(ApiPaths.baoHiem.layDsBaoHiemTheoNam + qs)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};
export const taiDuLieuBaoHiem = async (id: number) => {
    var rs: Array<ChiTietBaoHiem> = []
    await intance.get(ApiPaths.baoHiem.taiBaoHiemThang + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
}

export const taiBaoHiemBoSungTheoListNhanVien = async (id: number, listIdNV: number[]) => {
    var rs: Array<ChiTietBaoHiem> = []
    await intance.post(ApiPaths.baoHiem.taiBaoHiemBoSungTheoListNhanVien, { "id": id, "listIdNhanVien": listIdNV })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
}

export const thongTinNhanSuTinhBaoHiem = async (id: number) => {
    var rs: Array<ChiTietBaoHiem> = [];
    await intance.get(ApiPaths.baoHiem.thongTinNhanSuTinhBaoHiem + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });

    return rs;
};
export const luuDuLieuBaoHiem = async (request: any) => {
    var rs: Array<ChiTietBaoHiem> = []
    await intance.post(ApiPaths.baoHiem.luuBaoHiemThang, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
}
export const duyetBaoHiemXaHoi = async (id: number) => {
    await intance.post(ApiPaths.baoHiem.duyetBaoHiemThang + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
            } else {
                throw Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
}

export const layChiTietBaoHiem = async (id: number, where?: string) => {
    var rs: Array<ChiTietBaoHiem> = []
    if (!where) where = "";
    else where = "&where=" + where;
    await intance.get(ApiPaths.baoHiem.layChiTietBaoHiem + "?id=" + id+where)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}
export const LayThongTinBaoHiem = async (id: number) => {

    var data: BaoHiem = new BaoHiem();

    await intance.get(ApiPaths.baoHiem.layThongTinBaoHiem + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}
export const ThemBaoHiemThang = async (thangNam: any, loai: any) => {
    var data: BaoHiem = new BaoHiem();

    await intance.post(ApiPaths.baoHiem.themBaoHiemThang + "?thangNam=" + thangNam + "&loai=" + loai)
    .then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        } else {
            throw Error(res.data.thongBao);
        }
    })
    .catch((err) => {
        throw err;
    });

    return data;
}
export const XuatExcelBaoCao = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoHiem.xuatBaoCao + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const importFileBaoHiem = async (idBaoHiemThang: number, file: File) => {
    var rs: Array<ChiTietBaoHiem> = [];
    const formData = new FormData();
    formData.append("IdBaoHiemThang", idBaoHiemThang.toString());
    formData.append("File", file);
    await intance.post(ApiPaths.baoHiem.importFileBaoHiem, formData)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}